import { styled } from '@material-ui/core';
import { CSSProperties } from 'react';
export const editButtonStyles = {
  color: 'white',
  backgroundColor: 'rgba(0,0,0,0.4)',
  width: 'fit-content',
  height: 'fit-content',
  position: 'absolute',
  right: '20px',
  top: '30px',
  zIndex: 99,
} as CSSProperties;

export const backButtonStyles = {
  background: 'white',
  borderRadius: '10px',
  fontSize: '18px',
  width: 'fit-content',
  height: 'fit-content',
  position: 'absolute',
  left: '20px',
  top: '30px',
  zIndex: 99,
} as CSSProperties;

export const Image = styled('img')(() => ({
  width: '100%',
  maxHeight: '100vh',
  objectFit: 'contain',
}));

export const VideoCont = styled('div')(() => ({
  width: '100%',
  maxHeight: '100vh',
  objectFit: 'contain',

  '& video': {
    maxHeight: '100vh',
  },
}));
